
import { Prop, Component, Watch, Vue } from 'vue-property-decorator'

@Component({
  name: 'DropDown'
})
export default class DropDown extends Vue {
  @Prop({ type: Number, default: 15 }) offset: number
  @Prop({ type: String, default: 'bottom' }) placement: number
  @Prop({ type: Boolean, default: false }) open: number

  @Watch('open', { immediate: true })
  onOpenHandler(val) {
    this.shown = val
  }

  shown = false
}
